export default __webpack_public_path__ + "static/antigenTestResult_healgen-9943344ed474adefc29be2c24d78c077.jpg";